const SELECTORS = {
  body: 'body',
  stickySection: '.product-sticky-add-to-cart',
  stickyAddToCartBttn: '[data-sticky-add-to-cart-trigger]',
  originAddToCartBttn: '[data-add-to-cart-trigger]',
  stickyVariantSelect: '[data-select-variant]',
  originVariantSelect: '[data-radio-variant]',
  swatchVariantAvailbility: 'data-variant-option-available',
  className: 'active',
  bodyActiveStickyClass: 'sticky-cart-active',
  owlWidget: '.js-pushowl-bell-button',
  twkWidget: 'iframe[title="chat widget"]',
};

/**
 * @param {HTMLElement} stickyAddToCartBttn sticky add to cart button
 * @param  {HTMLElement} originAddToCartBttn default add to cart button
 * @param {boolean} isOriginBttnVisible true/false
 */
function triggerAddToCart(stickyAddToCartBttn, originAddToCartBttn, isOriginBttnVisible) {
  if (!isOriginBttnVisible) {
    stickyAddToCartBttn.addEventListener('click', () => {
      originAddToCartBttn.click();
    });
  }
}
/**
 * @param {HTMLElement} stickyAddToCartBttn sticky add to cart button
 * @param {boolean} isVariantAvailable true/false
 */
function toggleStickyButtonStyle(stickyAddToCartBttn, isVariantAvailable) {
  if (isVariantAvailable === 'false') {
    stickyAddToCartBttn.classList.add('disabled');
    stickyAddToCartBttn.setAttribute('disabled', 'disabled');
  } else if (isVariantAvailable === 'true' && stickyAddToCartBttn.classList.contains('disabled')) {
    stickyAddToCartBttn.classList.remove('disabled');
    stickyAddToCartBttn.removeAttribute('disabled');
  }
}
/**
 * @param {HTMLElement} stickyVariantSelect select in sticky section
 * @param {HTMLElement} originVariantSelect radio variant select on product card
 * @param {HTMLElement} stickyAddToCartBttn sticky add to cart button
 */
function triggerSelectVariant(stickyVariantSelect, originVariantSelect, stickyAddToCartBttn) {
  if (stickyVariantSelect && originVariantSelect) {
    // eslint-disable-next-line func-names
    let isVariantAvailable = null;
    stickyVariantSelect.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      const selectedValue = selectedOption.value;
      const originOptionLabel = originVariantSelect.querySelector(`[data-value="${selectedValue}"] label`);
      isVariantAvailable = originOptionLabel.parentNode.parentNode.querySelector(`[${SELECTORS.swatchVariantAvailbility}]`).getAttribute(SELECTORS.swatchVariantAvailbility);
      originOptionLabel.click();
      toggleStickyButtonStyle(stickyAddToCartBttn, isVariantAvailable);
    });
    originVariantSelect.querySelectorAll('[data-variant-option-value-label]').forEach((label) => {
      label.addEventListener('click', (e) => {
        const selectOption = stickyVariantSelect.querySelector(`option[value="${e.currentTarget.textContent.trim()}"`);
        isVariantAvailable = label.parentNode.parentNode.querySelector(`[${SELECTORS.swatchVariantAvailbility}]`).getAttribute(SELECTORS.swatchVariantAvailbility);
        selectOption.selected = true;
        toggleStickyButtonStyle(stickyAddToCartBttn, isVariantAvailable);
      });
    });
  }
}
/**
 * @param {HTMLElement} stickySection html sections
 * @param {boolean} active boolean param
 */
function updateAppsPosition(stickySection, active = false) {
  const body = document.querySelector(SELECTORS.body);

  /**
   * @param {object} mutationsList list
   * @param {object} observer object
   */
  // eslint-disable-next-line func-names
  const observerCallback = function (mutationsList, observer) {
    const pushowlWidget = document.querySelector(SELECTORS.owlWidget);
    const twkWidget = document.querySelector(SELECTORS.twkWidget);
    const tawkAPI = globalThis.Tawk_API || null;
    if (pushowlWidget && twkWidget && tawkAPI) {
      observer.disconnect();
      if (active) {
        twkWidget.style.transitionProperty = `bottom`;
        twkWidget.style.setProperty('inset', `auto 20px 130px auto`, 'important');
      } else {
        twkWidget.style.setProperty('inset', `auto 20px 20px auto`, 'important');
      }
    }
  };
  const observer = new MutationObserver(observerCallback);
  const observerConfig = { attributes: true, childList: true, subtree: true };
  observer.observe(body, observerConfig);
}

/**
 * @param {object} dom object with dom elements
 * @param {string } className class name
 */
function toggleStickyAddToCart(dom, className) {
  const body = document.querySelector(SELECTORS.body);
  const rect = dom.originAddToCartBttn.getBoundingClientRect();
  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  const isOriginBttnVisible = !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  if (isOriginBttnVisible && dom.stickySection.classList.contains(className)) {
    dom.stickySection.classList.remove(className);
    body.classList.remove(SELECTORS.bodyActiveStickyClass);
    triggerSelectVariant(dom.stickyVariantSelect, dom.originVariantSelect, dom.stickyAddToCartBttn);
    updateAppsPosition(dom.stickySection);
  } else if (!isOriginBttnVisible && !dom.stickySection.classList.contains(className)) {
    dom.stickySection.classList.add(className);
    body.classList.add(SELECTORS.bodyActiveStickyClass);
    updateAppsPosition(dom.stickySection, true);
    triggerSelectVariant(dom.stickyVariantSelect, dom.originVariantSelect, dom.stickyAddToCartBttn);
    triggerAddToCart(dom.stickyAddToCartBttn, dom.originAddToCartBttn, isOriginBttnVisible);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const stickySection = document.querySelector(SELECTORS.stickySection);
  const stickyAddToCartBttn = stickySection.querySelector(SELECTORS.stickyAddToCartBttn);
  const stickyVariantSelect = stickySection.querySelector(SELECTORS.stickyVariantSelect);
  const originVariantSelect = document.querySelector(SELECTORS.originVariantSelect);
  const originAddToCartBttn = document.querySelector(SELECTORS.originAddToCartBttn);
  const dom = { stickySection, stickyAddToCartBttn, stickyVariantSelect, originVariantSelect, originAddToCartBttn };
  if (window.innerWidth < 798 && stickySection && stickyAddToCartBttn) {
    toggleStickyAddToCart(dom, SELECTORS.className);
    window.addEventListener('scroll', () => {
      toggleStickyAddToCart(dom, SELECTORS.className);
    });
  }
});
